import request from "graphql-request";
import { useRouter } from "next/router";
import { createContext, useContext, useEffect, useState } from "react";
import { baseUrl } from "services/shared/Environment";

export interface AuthorPageContextValue {
  fullName: string;
  initialized: boolean;
}

function authorQuery(authorSlug: string) {
  return `
      query {
        author(slug: "${authorSlug}") {
            fullName
        }
      }
  `;
}

const defaultContextValues: AuthorPageContextValue = {
  fullName: "",
  initialized: false
};

export const AuthorPageContext = createContext(defaultContextValues);

async function getAuthorContextValue(
  authorSlug: string
): Promise<AuthorPageContextValue> {
  try {
    const result = await request(
      `${baseUrl()}/api/graphql`,
      authorQuery(authorSlug)
    );
    const fullName = result?.author?.fullName ?? ''
    return {
      fullName,
      initialized: true,
    };
  } catch (e) {
    return {
      ...defaultContextValues,
      initialized: true
    };
  }
}

export const AuthorPageContextProvider: React.FC = ({ children }) => {
  const [context, setContext] = useState<AuthorPageContextValue>(
    defaultContextValues
  );
  const router = useRouter();
  const slug = (router.query.slug as string) ?? "";

  useEffect(() => {
    if (slug) {
      getAuthorContextValue(slug).then((contextValue) => {
        setContext(contextValue);
      });
    }
  }, [slug]);

  console.log(context)

  return (
    <AuthorPageContext.Provider value={context}>
      {children}
    </AuthorPageContext.Provider>
  );
};

export function useAuthorPageContext() {
  const context = useContext(AuthorPageContext);
  return context;
}
